export default __webpack_public_path__ + "static/colours-white-1280x800-b321c36f332c1ad15319d7d960756ccc.jpg";